import React from 'react'
import {formatOfferPrice} from '@yandex-delivery/api/model/offer'
import {Grid, Radio, Slot, Text, Trail, Typography} from '@logistics-frontend/blocks'

import * as classes from './Offer.classes'
import {Surge} from '../Surge/Surge'
import type {Props} from './types'

export function Offer(props: Props): React.ReactElement<Props> {
  const {offer, onChange, errorMessage, value, country, currencySign, isPending = false} = props

  return (
    <Slot size="l">
      <Text className={classes.body}>
        <Typography thickness="medium" variant="body2">
          {offer.title}
        </Typography>
        <Typography className={isPending ? classes.skeleton : undefined} color="minor" variant="caption1">
          {offer.disableReason ? offer.disableReason : offer.intervalCaption}
        </Typography>
      </Text>
      {offer.surgeRatio > 1 && (
        <Trail ml="s">
          <Surge ratio={offer.surgeRatio} />
        </Trail>
      )}
      <Trail ml="s">
        <Grid alignItems="flex-end" direction="column" size="xs" container>
          <Typography
            className={isPending ? classes.skeleton : undefined}
            Component={Grid}
            thickness="medium"
            variant="body2"
            xs={12}
            item
          >
            {formatOfferPrice(offer, {country, currencySign})}
          </Typography>
        </Grid>
      </Trail>
      <Trail ml="s">
        <Radio
          checked={value?.tariff === offer.tariff}
          data-e2e={`tariff-${offer.tariff}`}
          error={errorMessage}
          onChange={function changeHandler() {
            onChange(offer)
          }}
        />
      </Trail>
    </Slot>
  )
}
